import React from "react";
import PropTypes from "prop-types";
import { useIntl } from "react-intl";
import { FormattedMessage } from "@learningblocks/shared-components/lib/FormattedMessage";
import style from "./style.module.scss";

const UNLIIMTED_ATTEMPTS = {
  VALUE: -10,
};
const INVISIBLE_ATTEMPTS = {
  VALUE: -1,
};
/**
 * TotalAttempts:
 *  - Component display TotalAttempts left for Question
 */
export function TotalAttempts(props) {
  const intl = useIntl();

  const renderTotalCount = () => {
    if (props.totalAttempts === UNLIIMTED_ATTEMPTS.VALUE) {
      return intl.formatMessage({
        id: "Unlimited",
        defaultMessage: "Unlimited",
        description: "",
      });
    } else {
      return props.totalAttempts;
    }
  };

  const className = `${style.attempts} ${props.className}`;

  return (
    <span
      className={className}
      style={{
        visibility:
          props.totalAttempts === INVISIBLE_ATTEMPTS.VALUE ? "hidden" : null,
      }}
    >
      {FormattedMessage({
        string: "Attempts left",
      })}
      : {renderTotalCount()}
    </span>
  );
}

TotalAttempts.propTypes = {
  /**
   * To display total attempts
   */
  totalAttempts: PropTypes.number.isRequired,
  /**
   * ClassName for the question wrapper
   */
  className: PropTypes.string,
};

TotalAttempts.defaultProps = {
  className: "",
  totalAttempts: 0,
};
